const config = {
    API_URL: 'https://backdemo.samnite.it/api',
};

export default config;

